import { FILTER_TYPE } from "utils/constants";

export const COLUMNS_DATA = () => [
  {
    Header: "S.No",
    accessor: "_index",
    disableSortBy: true,
    Cell: ({ row }) => row.index + 1,
  },
  {
    Header: "Employee Code",
    accessor: "employee_code_id",
    disableSortBy: true,
  },
  {
    Header: "Employee Name",
    accessor: "employee_name",
    disableSortBy: true,
  },
  {
    Header: "Total Franchise",
    accessor: "total_franchise",
    disableSortBy: true,
    Cell: ({ cell }) => cell.value ?? 0,
  },
  {
    Header: "Active Franchise",
    accessor: "active_franchise",
    disableSortBy: true,
    Cell: ({ cell }) => cell.value ?? 0,
  },
  {
    Header: "Inactive Franchise",
    accessor: "inactive_franchise",
    disableSortBy: true,
    Cell: ({ cell }) => cell.value ?? 0,
  },
  {
    Header: "Total Bookings",
    accessor: "total_bookings",
    disableSortBy: true,
    Cell: ({ cell }) => cell.value ?? 0,
  },
];

export const DETAIL_COLUMNS = () => [
  {
    Header: "S.No",
    accessor: "_index",
    disableSortBy: true,
    Cell: ({ row }) => row.index + 1,
  },
  {
    Header: "Franchise Code",
    accessor: "franchise_code",
    disableSortBy: true,
  },
  {
    Header: "Company Name",
    accessor: "company_name",
    disableSortBy: true,
    Cell: ({ cell }) => cell.value || "",
  },
  {
    Header: "Marketing Person",
    accessor: "marketing_person_obj",
    disableSortBy: true,
    Cell: ({ cell }) => cell.value || "",
  },
  {
    Header: "Total Booking Amount",
    accessor: "total_booking_amount",
    disableSortBy: true,
    Cell: ({ cell }) => (
      <span
        style={{
          fontWeight: "bold",
          color: "#28a745",
          fontSize: "14px",
        }}
      >
        {cell.value ? `${cell.value}` : "0"}
      </span>
    ),
  },
];

export const BRANCH_FORM_CONFIG = (rowData) => [
  {
    label: "Branch",
    type: "input-text",
    name: "branch",
    defaultValue: rowData?.branch || "",
    validations: {
      maxLength: 255,
      required: true,
    },
  },
  {
    label: "Branch Address",
    type: "input-text",
    name: "branch_address",
    defaultValue: rowData?.branch_address || "",
    validations: {
      maxLength: 255,
      required: true,
    },
  },
  {
    label: "City",
    type: "select",
    name: "city",
    defaultValue: rowData?.city || "",
    validations: {
      maxLength: 255,
      required: true,
    },
  },
  {
    label: "State",
    type: "select",
    name: "state",
    defaultValue: rowData?.state || "",
    options: [],
    validations: {
      required: true,
    },
  },
  {
    label: "PinCode",
    type: "input-text",
    name: "pincode",
    defaultValue: rowData?.pincode || "",
    validations: {
      maxLength: 6,
      required: true,
      pattern: {
        value: /^[0-9]+$/,
        message: "Please enter a valid PinCode",
      },
    },
  },
  {
    label: "Area Name",
    type: "input-text",
    name: "area_name",
    defaultValue: rowData?.area_name || "",
    validations: {
      maxLength: 255,
      required: true,
    },
  },
  {
    label: "Zone",
    type: "select",
    name: "zone_id",
    defaultValue: rowData?.zone_name || "",
    options: [],
    validations: {
      required: true,
    },
  },
];

export const OPTIONS = [
  // { key: "patient_name", value: "Patient Name" },
  { key: "appointment_id", value: "Appointment ID" },
  { key: "barcode_id", value: "Barcode" },
  { key: "registration_no", value: "Reg No" },
  { key: "patient_bill_no", value: "Patient Bill No" },
];
export const STATUS_OPTIONS = [
  { key: true, value: "Active" },
  { key: false, value: "In-Active" },
];

const today = new Date();
const pad = (n) => String(n).padStart(2, "0");
const formattedToday = `${today.getFullYear()}-${pad(today.getMonth() + 1)}-${pad(today.getDate())}`;

export const FILTER_DEFINATIONS = [
  {
    name: "date_from",
    type: FILTER_TYPE.DATE,
    initialValue: formattedToday,
  },
  {
    name: "date_to",
    type: FILTER_TYPE.DATE,
    initialValue: formattedToday,
  },
];
